// client/src/dnd/emitter_tool/runtime/Runtime_Parts/utils.js
import * as PIXI from "pixi.js";

export const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
export const lerp = (a, b, t) => a + (b - a) * t;
export const toNum = (v, d = 0) => (Number.isFinite(+v) ? +v : d);
export const DEG = Math.PI / 180;

export function blendModeOf(name) {
  switch ((name || "NORMAL").toUpperCase()) {
    case "ADD":
      return PIXI.BLEND_MODES.ADD;
    case "MULTIPLY":
      return PIXI.BLEND_MODES.MULTIPLY;
    case "SCREEN":
      return PIXI.BLEND_MODES.SCREEN;
    default:
      return PIXI.BLEND_MODES.NORMAL;
  }
}

const norm = (s) => String(s || "").trim().toLowerCase();

const baseNoExt = (str) => {
  const slash = Math.max(str.lastIndexOf("/"), str.lastIndexOf("\\"));
  const base = slash >= 0 ? str.slice(slash + 1) : str;
  const dot = base.lastIndexOf(".");
  return dot > 0 ? base.slice(0, dot) : base;
};

export function createTextureKeyResolver(textures) {
  const keys = Object.keys(textures || {});
  const exact = new Map();
  const basename = new Map();

  for (const key of keys) {
    exact.set(norm(key), key);
    basename.set(baseNoExt(key).toLowerCase(), key);
  }

  function resolveKey(req) {
    const low = norm(req);
    if (!low) return null;
    if (exact.has(low)) return exact.get(low);
    if (basename.has(low)) return basename.get(low);
    for (const key of keys) {
      if (norm(key).includes(low)) return key;
    }
    return null;
  }

  function resolveList(names) {
    const out = [];
    const seen = new Set();
    for (const raw of names || []) {
      if (raw == null) continue;
      const key = resolveKey(String(raw));
      if (key && !seen.has(key)) {
        seen.add(key);
        out.push(key);
      }
    }
    return out;
  }

  return {
    keys,
    resolveKey,
    resolveList,
  };
}

export function resolveListToKeys(textures, names) {
  return createTextureKeyResolver(textures).resolveList(names);
}

export function resolveSpriteSource({ spriteManager, textures }) {
  if (spriteManager && typeof spriteManager.getSpriteSource === "function") {
    const src = spriteManager.getSpriteSource();
    if (src && typeof src.reset !== "function") src.reset = () => {};
    return src;
  }
  const { keys } = createTextureKeyResolver(textures);
  const first = keys[0] || null;
  return {
    next: () => (first && textures[first]) ? textures[first] : PIXI.Texture.WHITE,
    reset() {},
  };
}

export const nowSec = () => {
  if (typeof performance !== "undefined" && performance.now) return performance.now() / 1000;
  return Date.now() / 1000;
};

export const clone = (o) => {
  try {
    return JSON.parse(JSON.stringify(o));
  } catch {
    return o;
  }
};

export const deepMerge = (a, b) => {
  const out = { ...(a || {}) };
  for (const k in (b || {})) {
    const v = b[k];
    if (v && typeof v === "object" && !Array.isArray(v)) out[k] = deepMerge(out[k], v);
    else out[k] = v;
  }
  return out;
};

export function safeSig(value) {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}
